import React from 'react';
import { Route } from 'react-router-dom';
//COMPONENTS
import RequestOverview from './requestOverview/requestOverview';
/* import CompanyRequestStepper from './companyRequest/companyRequest'; */
import SearchFlow from './searchFlow/searchFlow';
import ReferralDetails from './referral/refDetails';
import ReferralPage from './referral/referralPage';

const companyRoutes = (
  <Route path='/company'>
    {/* <Route path='/company/request/:formname' element={<SearchFlow />} /> <== parameterben megadni az urlt */}
    <Route path='/company/request/:step' element={<SearchFlow />} />
    <Route path='/company/request_overview/:id' element={<RequestOverview />} />
    <Route path='/company/refdetails' element={<ReferralDetails />} />
    <Route path='/company/referral' element={<ReferralPage />} />
  </Route>
);

export default companyRoutes;
